define( 'views/advanced/mainContent',['views/advanced/settingItem'], function( settingItem ) {
	var view = Marionette.CompositeView.extend({
		childView: settingItem,
		template: '#tmpl-nf-advanced-main-content',

		attachHtml: function( collectionView, childView ) {
			if('undefined' != typeof childView.model.get('modal_content')) {
				jQuery( collectionView.el ).find( '.available' ).append( childView.el );
				jQuery( collectionView.el ).find( '.sub-section-header' ).show();
			} else {
				jQuery( collectionView.el ).find( '.installed' ).append( childView.el );
			}
		}
	});

	return view;
} );
